import { createRouter, createWebHistory } from 'vue-router';
import HomePage from '@/pages/HomePage.vue';
import OpenCard from '@/components/OpenCard.vue';

const routes = [
  {
    path: '/',
    name: 'HomePage',
    component: HomePage,
  },
  {
    path: '/opencard/:id',
    name: 'OpenCard',
    component: OpenCard,
  },
];

const router = createRouter({
  routes,
  history: createWebHistory(),
});

export default router;
